import { createActions } from 'redux-actions';

export const actions = createActions(
  {},
  'ERROR_WS_CONNECTION_CHANGED_SHOW_MODAL',

  'ERROR_RECONNECT_ATTEMPT',
  'ERROR_RECONNECT_ATTEMPT_RESET',

  'ERROR_CONNECTION_LOST_SHOW_MODAL',
  'ERROR_CONNECTION_LOST_HIDE_MODAL',
  'ERROR_MICROPHONE_ERROR_SHOW_MODAL',
  'ERROR_MICROPHONE_ERROR_HIDE_MODAL',
);
